import PropTypes from 'prop-types';

const ChatIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.455 0H6.545A6.545 6.545 0 0 0 0 6.544v26.175a6.545 6.545 0 0 0 6.545 6.543h7.833l8.073 8.093a2.182 2.182 0 0 0 3.098 0l8.073-8.093h7.833A6.545 6.545 0 0 0 48 32.72V6.544A6.545 6.545 0 0 0 41.455 0zm-8.728 26.175H15.273a2.182 2.182 0 1 1 0-4.363h17.454a2.182 2.182 0 1 1 0 4.363zm0-8.725H15.273a2.182 2.182 0 1 1 0-4.363h17.454a2.182 2.182 0 1 1 0 4.363z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

ChatIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ChatIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ChatIcon;
